<template>
  <layout-fullpage>
    <loading :show="apiLoading" />
    <page-headline tag="h1" title="收據明細" />
    <details-page :detailData="detailData" :isPayerBtn="false"></details-page>
    <div>
      <div class="row align-items-center text-center mb-4 small">
        <div class="col-12 col-md mb-2 mb-md-0">
          <b-button
            v-if="detailData.rpStatus !== '9'"
            variant="action"
            size="sm"
            class="btn-miw mx-1 mb-2"
            @click="previewReceipt(detailData)"
            >收據預覽及歸戶</b-button
          >
          <go-home-btn
            :btnSize="'sm'"
            :btnClass="'btn-miw mx-1 mb-2'"
            :btnVariant="'primary'"
            :btnName="'回收據雲平台首頁'"
          >
            <template slot="goHomeBtn"></template>
          </go-home-btn>
        </div>
      </div>
    </div>

    <!-- Modal -->
    <!-- 收據預覽Modal -->
    <receipt-preview ref="receiptPreview"></receipt-preview>

    <!-- 注意事項 -->
    <notice-modal
      :getUrl="getUrl"
      @getDetailData="getDetailData"
      :title="'注意事項'"
    ></notice-modal>
  </layout-fullpage>
</template>

<script>
import LayoutFullpage from '@/layouts/Fullpage.vue';

// 共用 utils
import Loading from '@/components/Loading.vue';

export default {
  name: 'Details',

  components: {
    LayoutFullpage,
    Loading,
  },

  data() {
    return {
      detailData: {},
      rpPublicNo: null,
      rpPublicRandomCode: null,
      rpId: null,
      agreement: false,
      isDetailData: this.$store.state.details.isDetailData,
      apiLoading: false,
      getUrl: {},
    };
  },
  created() {
    console.log('isDetailData', this.isDetailData);
    this.detailData = this.$store.getters['details/getDetailData'];
    this.getUrl = this.$route.query;
    if (JSON.stringify(this.getUrl) !== '{}') {
      this.rpPublicNo = this.getUrl.rpPublicNo;
      this.rpPublicRandomCode = this.getUrl.rpPublicRandomCode;
      this.$nextTick(() => {
        this.$root.$emit('bv::show::modal', 'modal-agreement');
      });
    }
    // else {
    //   this.$nextTick(() => {
    //     if (!this.isDetailData) {
    //       // this.$router.push({
    //       //   name: 'home',
    //       // });
    //     }
    //   });
    // }
  },

  computed: {
    totalRows() {
      return this.resultData.length;
    },
  },

  methods: {
    getDetailData(data) {
      this.detailData = data;
    },
    previewReceipt(rowData) {
      this.rowData = rowData;
      const pdfnym = rowData.pdfNym;
      const data = {
        rpPublicNo: rowData.rpPublicNo,
        rpPublicRandomCode: rowData.rpPublicRandomCode,
      };
      const url = {
        preview: `/GovEReceipt/PdfService/previewPdf${pdfnym === null ? '' : `/${pdfnym}`}`,
        downloadPdf: `/GovEReceipt/PdfService/downloadPdf${pdfnym === null ? '' : `/${pdfnym}`}`,
      };
      this.$refs.receiptPreview.showModal(data, url);
    },
    goHome() {
      this.$router.push({
        name: 'home',
      });
    },
  },
};
</script>
